import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faUserCheck,
  faShieldAlt,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";


const Section4 = ({ url }) => {
  return (
    <>
      <section className="about-section-4">
        <div
          className="container about-us"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          <div className="panel-4-txt">
            <h2 className="title">What Drives Us to Excellence</h2>
            {/* <ul>
              <li>
                <strong style={{ color: "#fcb61d" }}>Passion </strong>  for solving real business problems
              </li>
              <li>
                <strong style={{ color: "#fcb61d" }}>Customer Centricity</strong> in every decision and solution
              </li>
              <li>
                <strong style={{ color: "#fcb61d" }}>Unflinching Integrity</strong> in processes, communication, and ethics
              </li>
              <li>
                <strong style={{ color: "#fcb61d" }}>Superior Profitability</strong> by delivering solutions that create lasting business value
              </li>
            </ul> */}

            <div className="values-grid">
              <div className="value-card">
                {/* <div> */}
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faChartLine} className="card-icon" color="#fff" />
                  </div>
                  <h4>Superior Profitability</h4>
                {/* </div> */}
                {/* <p>By delivering solutions that create lasting business value</p> */}
              </div>

              <div className="value-card">
                {/* <div style={{ marginTop: '-15px' }}> */}
                  <div className="icon-wrap">
                    <FontAwesomeIcon icon={faHeart} className="card-icon" color="#fff" />
                  </div>
                  <h4>Passion</h4>
                {/* </div> */}
                {/* <p>for solving real business problems</p> */}
              </div>

              <div className="value-card">
                {/* <div style={{ marginTop: '-15px' }}> */}
                <div className="icon-wrap">
                  <FontAwesomeIcon icon={faUserCheck} className="card-icon" color="#fff" />
                </div>
                <h4>Customer Centricity</h4>
                {/* </div> */}
                {/* <p>In every decision and solution</p> */}
              </div>

              <div className="value-card">
                {/* <div> */}
                <div className="icon-wrap">
                  <FontAwesomeIcon icon={faShieldAlt} className="card-icon"  color="#fff" />
                </div>
                <h4>Unflinching Integrity</h4>
                {/* </div> */}
                {/* <p>In processes, communication, and ethics</p> */}
              </div>


            </div>


            {/* <div className="divider">

            </div> */}
            <h5>
              <strong style={{ color: "#fcb61d" }}>ExD Digital</strong> exists to help businesses build, scale, and lead with confidence in a rapidly evolving digital landscape—through technology that works, systems that scale, and partnerships that last.
            </h5>
          </div>
          <div className="work-together-text">
            <h5>
              Let's Work Together
            </h5>
            Whether you're a startup looking to establish your digital presence
            or an established brand seeking a fresh perspective, ExD Digital is
            here to help you succeed. Let's collaborate and embark on a digital
            journey that will elevate your brand to new heights. Join us in
            shaping your future in the digital world!
          </div>
        </div>
      </section>
    </>
  );
};

export default Section4;
